'use es6';

import { createSelector } from '@reduxjs/toolkit';
import { isFailed } from 'conversations-async-data/async-data/operators/statusComparators';
import { getAsyncPubSubClient } from 'conversations-internal-pub-sub/redux/selectors/pubSubClientGetters';
export const pubsubConnectionFailed = createSelector([getAsyncPubSubClient], isFailed);